import { observer } from "mobx-react-lite";
import React from "react";

const AdminModalBody = ({ bodyContent, loading }: any) => {
  let isFunc = typeof bodyContent === "function";
  return (
    <div className="modal-body request-modal--body">
      {loading === true ? (
        <div className="loader main-loader" />
      ) : isFunc ? (
        bodyContent()
      ) : (
        bodyContent
      )}
    </div>
  );
};

export default observer(AdminModalBody);
